import { Preferences } from 'pleinchamp-api-client';
import React, { FC, useCallback, useState } from 'react';
import { BecomeProOverlay } from '@components/BecomeProOverlay/BecomeProOverlay.component';
import { City } from '@meteo/types';
import { NotificationList } from '@notifs/components/NotificationList/NotificationList.component';
import NotificationsSelection from '@notifs/components/NotificationsSelection/NotificationsSelection.component';
import { PlcNotification } from '@notifs/types';
import { SettingsState } from '@settings/business/Settings.store';

interface NotifTabProps {
  notifications: PlcNotification[];
  favoriteLocalities: City[];
  isPro: boolean;
  settings: SettingsState;
  saveSettings: (preferences: Preferences) => Promise<void>;
  savingSettings: boolean;
  saveSettingsError: string | undefined;
}

export const WeatherNotifTab: FC<NotifTabProps> = ({
  favoriteLocalities,
  notifications,
  isPro,
  settings,
  saveSettings,
  savingSettings,
  saveSettingsError,
}) => {
  const {
    pushNotificationDenied,
    preferences: { pushNotificationEnabled, emailNotificationEnabled },
  } = settings;
  const [shouldEnableNotification, setShouldEnableNotification] = useState(
    notifications.length === 0 && !pushNotificationEnabled && !emailNotificationEnabled
  );
  const handleNotificationSelectionChange = useCallback(
    (pushEnabled, emailEnabled) => {
      const newSettings = {
        ...settings.preferences,
        emailNotificationEnabled: emailEnabled,
        pushNotificationEnabled: pushEnabled,
      };
      saveSettings(newSettings);
      setShouldEnableNotification(false);
    },
    [saveSettings]
  );

  if (!isPro) {
    return (
      <div className="wrapper-s">
        <BecomeProOverlay asOverlay={false} i18nTitle="notifications.not-pro.title" isCondensed={false} />
      </div>
    );
  }

  function handleNotificationCreated() {
    // Enable push and email notifications if first notification created
    if (shouldEnableNotification) {
      handleNotificationSelectionChange(true, true);
    }
  }

  return (
    <>
      <NotificationsSelection
        disabled={savingSettings}
        emailNotificationEnabled={emailNotificationEnabled}
        error={saveSettingsError}
        favorites={favoriteLocalities}
        isPro={isPro}
        onChange={handleNotificationSelectionChange}
        pushNotificationDenied={pushNotificationDenied}
        pushNotificationEnabled={pushNotificationEnabled}
      />
      <NotificationList
        favoriteLocalities={favoriteLocalities}
        notifications={notifications}
        onNotificationCreated={handleNotificationCreated}
      />
    </>
  );
};
